import isServer from 'detect-node';
import * as _throttle from 'raf-throttle';
export var throttle = !isServer
    ? _throttle.default || _throttle
    : function (f) { return function () { return undefined; }; };
